import { createStore, applyMiddleware, compose } from "redux";
import createSagaMiddleware from "redux-saga";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from "./reducers";
import rootSaga from "./sagas";
import { configureStore } from "@reduxjs/toolkit";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";

// Add proper persist configuration
const persistConfig = {
  key: 'root',
  storage,
/*   whitelist: [
    'Login',
    'Auth',
    'Users', 
    'Groups', 
    'Releases', 
    'ReleaseNotes', 
    'Notifications', 
    'Parameters', 
    'Comments', 
    'Projects', 
    'Products', 
    'Brands', 
    'Components', 
    'Categories', 
    'Documents', 
    'Configurations', 
    'Sectors', 
    'Agencies', 
    'Departments'
  ], */
  stateReconciler: autoMergeLevel2,  // Helps with proper state merging during rehydration
  debug: false
}

// Create the persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: persistedReducer, // Use the persisted reducer
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          'persist/PERSIST', 
          'persist/REHYDRATE', 
          'persist/PURGE'
        ],
        ignoredActionPaths: [
          'meta.arg', 
          'payload.timestamp', 
          'register', 
          'rehydrate', 
          'result',
          'payload.history',
          'payload.navigate'
        ],
      },
    }).concat(sagaMiddleware)
});

sagaMiddleware.run(rootSaga);

export const persistor = persistStore(store, null, () => {
  // console.log('Rehydration completed');
});